module.exports = __webpack_public_path__ + "img/guanggao.269e96db.png";